import actionBar from './actionBar.json';
import addContent from './addContent.json';
import addItemToCalendar from './addItemToCalendar.json';
import addToCalendarModal from './addToCalendarModal.json';
import auth from './auth.json';
import calendarFeedPlatformGrid from './calendarFeedPlatformGrid.json';
import categorySelect from './categorySelect.json';
import common from './common.json';
import createAiSchedule from './createAiSchedule.json';
import createSnippetPopover from './createSnippetPopover.json';
import dashboard from './dashboard.json';
import districtPlannerLanding from './districtPlannerLanding.json';
import editSnippetModal from './editSnippetModal.json';
import entryMessageForm from './entryMessageForm.json';
import entryModal from './entryModal.json';
import eventMessages from './eventMessages.json';
import experience from './experience.json';
import filterPopover from './filterPopover.json';
import fundraiserPlannerLanding from './fundraiserPlannerLanding.json';
import header from './header.json';
import importEntries from './import.json';
import labelSelect from './labelSelect.json';
import leaveScheduleConfirm from './leaveScheduleConfirm.json';
import members from './members.json';
import membersSelect from './membersSelect.json';
import messageBubble from './messageBubble.json';
import paidPlannerLanding from './paidPlannerLanding.json';
import pendingInvitations from './pendingInvitations.json';
import plannerLanding from './plannerLanding.json';
import plannerOnboarding from './plannerOnboarding.json';
import quickCreatePopover from './quickCreatePopover.json';
import resetPassword from './resetPassword.json';
import resetPasswordRequest from './resetPasswordRequest.json';
import richTextEditor from './richTextEditor.json';
import rsvpBar from './rsvpBar.json';
import save from './save.json';
import schedule from './schedule.json';
import scheduleMessages from './scheduleMessages.json';
import scheduleSettingsModal from './scheduleSettingsModal.json';
import settingsModal from './settingsModal.json';
import shareModal from './shareModal.json';
import snippetIngredientInUseModal from './snippetIngredientInUseModal.json';
import sources from './sources.json';
import updateAvailableCallout from './updateAvailableCallout.json';

export const en = {
  common,
  resetPasswordRequest,
  resetPassword,
  entryModal,
  experience,
  header,
  schedule,
  dashboard,
  filterPopover,
  actionBar,
  sources,
  import: importEntries,
  categorySelect,
  shareModal,
  members,
  entryMessageForm,
  eventMessages,
  richTextEditor,
  updateAvailableCallout,
  scheduleMessages,
  createAiSchedule,
  createSnippetPopover,
  editSnippetModal,
  snippetIngredientInUseModal,
  addToCalendarModal,
  calendarFeedPlatformGrid,
  labelSelect,
  leaveScheduleConfirm,
  settingsModal,
  membersSelect,
  messageBubble,
  pendingInvitations,
  districtPlannerLanding,
  plannerLanding,
  fundraiserPlannerLanding,
  paidPlannerLanding,
  scheduleSettingsModal,
  save,
  rsvpBar,
  addItemToCalendar,
  auth,
  addContent,
  quickCreatePopover,
  plannerOnboarding,
};
